import { render, staticRenderFns } from "./ProductGroupSelectAutocompleteSimple.vue?vue&type=template&id=ea211bb8&scoped=true"
import script from "./ProductGroupSelectAutocompleteSimple.vue?vue&type=script&lang=ts"
export * from "./ProductGroupSelectAutocompleteSimple.vue?vue&type=script&lang=ts"
import style0 from "./ProductGroupSelectAutocompleteSimple.vue?vue&type=style&index=0&id=ea211bb8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea211bb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea211bb8')) {
      api.createRecord('ea211bb8', component.options)
    } else {
      api.reload('ea211bb8', component.options)
    }
    module.hot.accept("./ProductGroupSelectAutocompleteSimple.vue?vue&type=template&id=ea211bb8&scoped=true", function () {
      api.rerender('ea211bb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product-group/ProductGroupSelectAutocompleteSimple.vue"
export default component.exports